import EventEmitter from 'eventemitter3'
import { get, set } from 'lodash'

export default () => {
  const eventEmitter = new EventEmitter()
  const data = {
    dataSource: [],
    pagination: {},
    formData: {},
    submittedFormData: {},
  }

  return {
    setData: (key, val) => {
      set(data, key, val)
    },

    getFormData: (name) => get(data, `formData${name ? '.' + name : ''}`),
    getSubmittedFormData: (name) => get(data, `submittedFormData${name ? '.' + name : ''}`),
    getTableDataSource: () => get(data, 'dataSource'),
    getPagination: () => get(data, 'pagination'),

    setFormData: (formData, needSearch = true) => {
      set(data, 'formData', formData)
      eventEmitter.emit('setFormData', formData, needSearch)
    },
    resetFormData: (needSearch = false) => {
      eventEmitter.emit('resetFormData', needSearch)
    },
    setTableDataSource: (dataSource) => {
      set(data, 'dataSource', dataSource)
      eventEmitter.emit('setTableDataSource', dataSource)
    },
    setPagination: (pagination) => {
      set(data, 'pagination', pagination)
      eventEmitter.emit('setPagination', pagination)
    },

    // 重置记忆数据，form、pagination
    resetMemoryData: () => {
      data.formData = {}
      data.pagination = {}
    },

    search: (params = {}, showLoading = true) => {
      return new Promise((resolve) => {
        eventEmitter.emit('search', params, {
          callback: resolve,
          showLoading,
        })
      })
    },

    on: (eventName, callback) => {
      eventEmitter.on(eventName, callback)
    },

    emit: (...args) => {
      eventEmitter.emit(...args)
    },

    removeListener: (...args) => {
      eventEmitter.removeListener(...args)
    },

    off: (...args) => {
      eventEmitter.removeListener(...args)
    },
  }
}
